import ContentType from "./ContentType";
import './assets/content-type.scss'



export default ContentType;